import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { ActionConfirmModalComponent } from './action-confirm-modal.component';
import { ActionConfirmModalService } from './action-confirm-modal.service';

@NgModule({
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    FlexLayoutModule,
    FlexModule
  ],
  declarations: [ActionConfirmModalComponent],
  entryComponents: [ActionConfirmModalComponent],
  providers: [ActionConfirmModalService],
  exports: [ActionConfirmModalComponent]
})
export class ActionConfirmModalModule { }
